import json2csv from 'json2csv';
import {saveAs} from 'file-saver';
import fileDownload from 'react-file-download';
import moment from 'moment'

const arrayToCsv = (data) => {
    let result = "";
    if (!data.length) {
        return result;
    }
    let fields = [];
    for (let i = 0; i < data.length; i++) {
        for (let key in data[i]) {
            if (data[i].hasOwnProperty(key) && -1 === fields.indexOf(key)) {
                fields.push(key);
            }
        }
    }
    result += json2csv.parse(data, {
        fields
    });
    return new Blob([
        '\uFEFF', result
    ], {
        type: 'text/plain;charset=utf-8'
    });
};

export const saveSCVToFile = (data, name, err) => {
    const csv = arrayToCsv(data);
    if (csv) {
        saveAs(csv, name, true);
    } else {
        err('no csv data');
    }
};
export const download = (data, name) => {
    fileDownload(data, name);
};

export const convertEtaToHours = (eta) => {
    if (eta === null) {
        return '';
    }
    let hours = Math.trunc(eta / 60),
        minutes = Math.abs(eta % 60);
    if (hours) {
        if (Math.abs(hours) <= 9) {
            if (hours < 0) {
                hours = `-0${Math.abs(hours)}`;
            } else {
                hours = `0${hours}`;
            }
        }
        if (minutes <= 9) {
            minutes = `0${minutes}`;
        }
        return `${hours}:${minutes}`;
    }
    return eta;
};

export const convertEtaToMinutes = (eta) => {
    if (eta === null) {
        return eta;
    }

    const regExp = new RegExp('^\\-?\\d+$'),
        time = eta.split(':');
    if (time.length !== 2) {
        if (!regExp.test(eta)) {
            return null;
        }
        return Number.parseInt(eta, 10);
    }

    let hours = time[0],
        minutes = time[1];
    if (!regExp.test(hours) || !regExp.test(minutes)) {
        return null;
    }
    if (hours.indexOf('-') !== -1) {
        minutes = '-' + minutes;
    }
    hours = Number.parseInt(hours, 10);
    minutes = Number.parseInt(minutes, 10);

    return (hours * 60) + minutes;
};

export const redirectToOkTellTab = (url, phone, target) => {
    if (typeof window !== 'undefined') {
        window.open(url + '(' + phone + ')', target);
    }
}

export const calculateActualAmount = (order) => {
    let actualAmount = order.deliveryPrice;
    order.shops.forEach(shop => shop.collectedOrderAmount ? actualAmount += Number(shop.collectedOrderAmount) : actualAmount += shop.price);

    return actualAmount;
}

export const transformMapToArray = (map) => {
    const array = [];
    for(let key in map) {
        array.push(map[key]);
    }
    return array;
};

export const formatDateTime = (dateTime, format ='DD/MM/YYYY HH:mm') => {
    if (!dateTime) {
        return '';
    }
    return moment(dateTime).format(format);
}
